import { usePersistPreferredLanguage } from '@/hooks/usePersistPreferredLanguage.ts';
import { useRefreshQueriesOnLanguageChange } from '@/hooks/useRefreshQueriesOnLanguageChange.ts';
import { AuthenticationDataProvider } from '@/utils/providers/authetnitactionDataContext/AuthenticationDataProvider.tsx';
import { UserProvider } from '@/utils/providers/userContext/UserProvider.tsx';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import React, { PropsWithChildren } from 'react';
import { ThemeProvider } from 'react-bootstrap';

import { muiTheme } from '../config/muiTheme';
import { QueryClientWrapper } from '../config/QueryClientWrapper';

const LanguageChangeQueryRefresher: React.FC = () => {
  useRefreshQueriesOnLanguageChange();
  return null;
};

// Needs the logged-in user, so it lives inside UserProvider
const PreferredLanguagePersister: React.FC = () => {
  usePersistPreferredLanguage();
  return null;
};

export const Providers: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <QueryClientWrapper>
      <LanguageChangeQueryRefresher />
      <AuthenticationDataProvider>
        <UserProvider>
          <PreferredLanguagePersister />
          <MuiThemeProvider theme={muiTheme}>
            <ThemeProvider>{children}</ThemeProvider>
          </MuiThemeProvider>
        </UserProvider>
      </AuthenticationDataProvider>
    </QueryClientWrapper>
  );
};
